// Una pantalla del mapa del ERP que todavía no está construida, o que no tiene backend. Se navega
// igual que cualquier otra (tiene su ruta y su ventana) y dice con honestidad qué hay: qué la
// alimentará, qué acciones existen y cuáles faltan. NO simula datos ni éxitos.
import { InsigniaBackend, NoDisponible, SinFuente } from '../comun/ui';
import { NOMBRE_ESTADO, pantallaPorRuta } from './navegacion';
import { useModoRevision } from './salud';

export function PantallaPreparada({ ruta }: { ruta: string }) {
  const p = pantallaPorRuta(ruta);
  const revision = useModoRevision();
  if (!p) return <p className="apagado">Pantalla desconocida: {ruta}</p>;
  return (
    <div className="pantalla preparada" data-pantalla="preparada" data-ruta={p.ruta}>
      <header className="encabezado-entidad">
        <div className="ruta-migas" aria-label="Ruta de la pantalla">
          {p.modulo.nombre}
          {p.seccion ? ` › ${p.seccion}` : ''} › <b>{p.nombre}</b>
        </div>
        <h2>
          {p.nombre} <InsigniaBackend estado={p.backend} />
        </h2>
        <p className="apagado">{p.descripcion}</p>
      </header>

      {p.sinFuente && <SinFuente />}

      <NoDisponible
        titulo="Pantalla en construcción"
        motivo={
          p.backend === 'C'
            ? 'Todavía no hay backend: la pantalla queda preparada y sin acciones.'
            : `El backend ${p.backend === 'A' ? 'ya existe' : 'existe en parte'}; la pantalla se construye${
                p.checkpoint ? ` en el checkpoint ${p.checkpoint}` : ''
              }.`
        }
      />

      {revision && (
        <section className="panel-revision" aria-label="Detalle para revisión">
          <h3>
            Revisión · {p.backend} — {NOMBRE_ESTADO[p.backend]}
          </h3>
          <dl className="ficha-revision">
            <dt>Ruta</dt>
            <dd className="mono">#/{p.ruta}</dd>
            <dt>Permiso</dt>
            <dd className="mono">{p.permiso ?? '—'}</dd>
            <dt>API</dt>
            <dd className="mono">{p.api?.length ? p.api.join(' · ') : 'sin contrato'}</dd>
            <dt>Acciones habilitadas</dt>
            <dd>{p.habilitadas?.length ? p.habilitadas.join(' · ') : 'ninguna todavía'}</dd>
            <dt>Acciones pendientes</dt>
            <dd>{p.pendientes?.length ? p.pendientes.join(' · ') : '—'}</dd>
            {p.checkpoint && (
              <>
                <dt>Checkpoint</dt>
                <dd>{p.checkpoint}</dd>
              </>
            )}
          </dl>
        </section>
      )}
    </div>
  );
}
